import React, {useContext} from 'react';
import * as R from 'ramda';
import {SystemConfigCtx} from '@/contexts';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Nav, NavItem} from 'reactstrap';
import {LocaleNavLink} from '@/routes';
import {blank, mapWithIndex} from '@/util';
import styles from '@/views/Layout/b2b/index.module.css';
import usePermission from '@/hooks/usePermission';

const MenuList = () => {
  const permission = usePermission();
  const {t: tr} = useTranslation('nb');
  const {siteCode} = useContext(SystemConfigCtx);

  const items = R.map(R.zipObj(['linkName', 'path']))([
    [tr('new_business'), '/'],
    ...(siteCode === 'absg'
      ? []
      : [[tr('service_records'), '/service_records']]),
    [tr('clients'), '/clients'],
    [tr('reports'), '/reports'],
    [tr('my_profile'), '/my_profile'],
    ...(siteCode === 'absg' ? [[tr('mdrt'), '/mdrt']] : []),
  ]);

  if (permission.canAccessB2BCommission()) {
    items.push({linkName: tr('commissions'), path: '/commissions'});
  }

  const itemList = mapWithIndex((item, idx) => (
    <NavItem key={idx}>
      <LocaleNavLink
        to={`/b2b${item.path}`}
        activeStyle={{
          backgroundColor: '#005a95',
          color: 'white',
        }}
        style={{color: '#005a95'}}
      >
        {item.linkName}
      </LocaleNavLink>
    </NavItem>
  ))(items);

  if (blank(siteCode)) {
    return null;
  }

  return (
    <Card className='mb-4'>
      <CardBody className={styles.link_menu_box_body}>
        <Nav className='nav flex-column nav-pills'>{itemList}</Nav>
      </CardBody>
    </Card>
  );
};

export default MenuList;
